<template>
  <div class="my-center">
    <!-- 公司信息 -->
    <div class="company-mes c-s">
      <div class="left c-c">
        <div class="head-img">
          <template v-if="userpic">
            <img style="border-radius: 50%" :src="userpic" />
            <img
              @click="login"
              class="refresh"
              src="../assets/images/images/refresh.png"
            />
          </template>
        </div>
        <div class="main-tag c-c-l f-d-c">
          <div class="tag-small c-c" >
            <div v-if="userStatus" style="position: relative;">
              <img src="../assets/images/images/svipImg.png" alt />
              <div class="vip-dengji">{{userStatus}}</div>
            </div>
            <div v-else>
              <img style="filter:grayscale(100%)" src="../assets/images/images/supvipGray.png"/>
            </div>
            <div v-if="!isSvip">
              <div @click="jumpSupVipPage">开通超级会员</div>
            </div>
            <div v-else>
              <div @click="jumpSupVipPage">续费超级会员</div>
            </div>
          </div>
          <template v-if="username">
            <div class="f11 t128 f11 company-name">{{ username }}</div>
          </template>
        </div>
      </div>
      <div class="c-c f-d-c service" @click="contact()">
        <div class="service-pic">
          <img src="../assets/images/images/service.gif" alt />
        </div>
        <div class="contact-service f11" style="color: rgb(153, 51, 153)">
          联系客服
        </div>
      </div>
    </div>
    <!--立即续费-->
    <div class="payMoney" @click="goXFPage" v-if="leftDay.type && leftDay.type == 'soon'">
      <div>你的门店会员 即将到期，立即续费，享超多VIP权限 ></div>
    </div>
    <div class="payMoney" @click="goXFPage" v-if=" leftDay.type && leftDay.type == 'over'">
      <div>你的门店会员 已经到期，立即续费，享超多VIP权限 ></div>
    </div>
    <div class="listOne" style="margin-top: 10px">
      <div
        @click="myMessage()"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div :class="userInfoData.unread_notify == '1'?'brage-icon-active':'brage-icon'">
          {{ userInfoData.letter_num }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
          <div class="wealthy-pic">
            <img src="../assets/images/images/center6.png" alt />
          </div>
          <div style="margin-top: 5px">我的通知</div>
          <!-- <div>{{ userInfoData.letter_num }}</div> -->
        </div>
      </div>
      <div
        @click="goMyPush"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border-top: 1px solid #fff;
          border-bottom: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div :class="userInfoData.unread_message == '1'?'brage-icon-active':'brage-icon'">
          {{ userInfoData.message_num }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
          <div class="wealthy-pic">
            <img src="../assets/images/images/center2.png" alt />
          </div>
          <div style="margin-top: 5px">我的发布</div>
          <!-- <div>{{ userInfoData.message_num }}</div> -->
        </div>
      </div>
      <div
        @click="gosetTop"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
        <div class="wealthy-pic">
          <img src="../assets/images/images/setToTop.png" alt />
        </div>
        <div style="margin-top: 5px">开通置顶</div>
        </div>
      </div>
    </div>
    <div class="listOne">
      <div
        @click="goSaveShop"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border-left: 1px solid #fff;
          border-bottom: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
          <div class="wealthy-pic">
            <img src="../assets/images/images/center5.png" alt />
          </div>
          <div style="margin-top: 5px">关注的店铺</div>
          <!-- <div>{{ userInfoData.remark_shop_num }}</div> -->
        </div>
      </div>
      <div
        @click="goSaveGoods"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border-left: 1px solid #fff;
          border-bottom: 1px solid #fff;
          border-right: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
          <div class="wealthy-pic">
            <img src="../assets/images/images/center4.png" alt />
          </div>
          <div style="margin-top: 5px">收藏的宝贝</div>
          <!-- <div>{{ userInfoData.remark_good_num }}</div> -->
        </div>
      </div>
      <div
        @click="goMyShop"
        style="
          padding: 8px 0;
          width: 0px;
          flex-grow: 1;
          border-right: 1px solid #fff;
          border-bottom: 1px solid #fff;
          display: flex;
          align-item: center;
          justify-content: center;
          position: relative;
        "
      >
        <div class="brage-icon" v-if="userInfoData.shop_id != 'cchc' && userInfoData.shop_id != 0 && userInfoData.shop_status">{{ userInfoData.good_num }}</div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            color: #4d4d4d;
            font-size: 13px;
          "
        >
          <div class="wealthy-pic">
            <img src="../assets/images/images/center3.png" alt />
          </div>
          <div
            style="margin-top: 5px"
            v-if="userInfoData.shop_id == 0 || !userInfoData.shop_status"
          >
            申请入驻
          </div>
          <div
            style="margin-top: 5px"
            v-if="
              userInfoData.shop_id != 'cchc' &&
              userInfoData.shop_id != 0 &&
              userInfoData.shop_status
            "
          >
            我的店铺
          </div>

          <!-- <div style="height: 15px">
            <div
              v-if="userInfoData.shop_id != 'cchc' && userInfoData.shop_id != 0"
            >
              {{ userInfoData.good_num }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 16px;
      "
    >
      <div @click="goOther">
        <img
          style="width: 100%; height: 100%"
          :src="banner && banner.thumb_url"
        />
      </div>
    </div>
    <div>
      <RecommendPostList
              style="margin-top: 8px"
              v-for="(item, index) in recommedPostList"
              :key="index"
              :mes="item"
              :bigPic="false"
            ></RecommendPostList>
    </div>
    <div class="icp_info" v-html="icpHtml"></div>
    <!-- <div class="copy-right" style="margin-top:10px;">Copyright (C) 2019-2022</div>
		<div class="copy-right">上海领策网络科技有限公司版权所有</div>
		<div class="copy-right">ICP许可证：沪B2-20220655</div>
		<div class="copy-right">沪ICP备14014580号-1</div> -->
    <div style="width:100%;height:30px;"></div>
    <HomeTab></HomeTab>
    
  </div>
</template>

<script>
let me;
import { ImagePreview } from "vant";
import { getData, postData } from "../Interface/http.js";
import { Dialog } from "vant";
import HeadItemThree from "../components/HeadItemThree";
import HomeTab from "../components/HomeTab";
import RecommendPostList from "../components/recommendPostList.vue";
export default {
  name: "MyCenter",
  data() {
    return {
      images: [],
      articleList: [],
      page: 1,
      category: "",
      loading: false,
      finished: false,
      message: {},
      myMes: 0,
      username: "",
      userpic: "",
      banner: {}, //广告图
      userInfoData: {
        message_num: 0,
        remark_shop_num: 0,
        remark_good_num: 0,
        good_num: 0,
        letter_num: 0,
        shop_id: "cchc",
      },
      leftDay: {
        type: ''
      }, //VIP剩余多少天数
      vipStatus: {}, //vip状态
      isVip: false, //是否是vip
      isSvip: false, //是否是超级vip
      isShop: 0, //是否是店铺
      mindList: [], //智能推荐的帖子列表
      userStatus: "", //当前会员等级
      recommedPostList: [],//推荐帖子列表
      icpHtml: ''
    };
  },
  components: {
    HomeTab,
    HeadItemThree,
    RecommendPostList
  },
  methods: {
    getIcpInfo() {
      getData('/article/icp').then(res => {
        if(res.code == 0) {
          this.icpHtml = res.data.content
        }
      })
    },
    //获取会员等级   
    getUseStatus() {
      getData("/vip/level", {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          if (res.data) {
            me.userStatus = res.data.vip_level + res.data.svip_level ;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取智能推荐的帖子列表
    getRecommentList() {
      getData("/smart/like", {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          me.recommedPostList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转超级会员页面
    jumpSupVipPage() {
      me.$router.push({
        path: "superVip",
      });
    },
    //跳转消息列表页面
    myMessage() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      me.$router.push({
        path: "noticeList",
      });
    },
    gosetTop() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      me.$router.push({
        path: "setTop",
      });
    },
    //查询用户是否是vip
    checkUserIsVip() {
      getData("/vip/is-vip",{
          token: localStorage.getItem("token")
            ? localStorage.getItem("token")
            : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
        }).then((res) => {
        me.isVip = res.data.vip;
      });
    },
    //查询用户是否是Svip
    checkUserIsSVip() {
      getData("/vip/is-vip?belongs=2",{
          token: localStorage.getItem("token")
            ? localStorage.getItem("token")
            : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
        }).then((res) => {
          me.isSvip = res.data.vip;
      });
    },
    //获取用户当前的开通状态
    getUserStatus() {
      postData("/vip/is-pay", {
        type: "store",
      })
        .then((res) => {
          me.vipStatus = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询会员到期时间
    getVipTimeOut() {
      getData("/vip/check-validity-date")
        .then((res) => {
          me.leftDay = Object.assign({},res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转到续费页面
    goXFPage() {
      this.$router.push({
        name: "continuePay",
        query: {
          id: me.userInfoData.shop_id,
        },
      });
    },
    //调起支付
    payMoney() {
      postData("http://jfc.dev.keepleft.cn/api/v2/payment/order/create", {
        trade_type: "mp",
        plan_id: "1",
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      });
    },
    getUserInfo() {
      let me = this;
      getData("/user/info", {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = Object.assign({}, res.data);
            sessionStorage.setItem("userInfoData", JSON.stringify(res.data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goMyPush() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      this.$router.push({
        name: "myPushMsg",
      });
    },
    goMyShop() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      let me = this;
      if (me.leftDay.type == "over") {
        Dialog.confirm({
          // title: "下架",
          message: "你之前的门店已过期，是否续费",
        })
          .then(() => {
            me.goXFPage();
          })
          .catch(() => {
            console.log("取消");
          });
        return;
      }
      if (me.userInfoData.shop_id == 0 || !me.userInfoData.shop_status) {
        if ( me.vipStatus && me.vipStatus.type == "on") {
          this.$toast("后台正在审核，请勿重新申请！");
          return;
        }
        this.$router.push({
          name: "addShop",
        });
      } else {
        this.$router.push({
          name: "mangerMyShop",
          query: {
            shop_id: me.userInfoData.shop_id,
          },
        });
      }
    },
    goOther() {
      window.location.href = this.banner.url;
    },
    goSaveShop() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      //跳转到关注店铺列表页面
      this.$router.push({
        name: "hasSaveShop",
      });
    },
    goSaveGoods() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      //跳转到收藏的宝贝列表页面
      this.$router.push({
        name: "hasSaveGoodsList",
      });
    },
    login() {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "myCenter");
        window.location.href = res.data.redirect_url;
      });
    },
    getMyMessage() {
      let token = localStorage.getItem("token");
      getData("/user/profile")
        .then((res) => {
          this.message = res.data;
          this.isShop = res.data.is_shop;
          this.userpic = this.message.avatar;
          this.username = this.message.nickname;
          localStorage.setItem("pic", this.message.avatar);
          localStorage.setItem("username", this.message.nickname);
          this.myMes = this.message.notifies.length;
          if (res.data.is_vip) {
            this.$store.commit("UPDATEVIP");
          }
        })
        .catch((err) => {
          me.login();
        });
    },
    myCount() {
      this.$toast("此项功能暂未开通");
    },
    myNotice() {
      if (this.myMes == 0) return;
      this.$router.push({ name: "tips", params: { mes: this.message } });
    },
    open() {
      this.$toast("需联系客服开通");
    },
    contact() {
      ImagePreview(this.images);
    },
    setMessage() {
      let name = localStorage.getItem("username");
      let pic = localStorage.getItem("pic");
      if (name && pic) {
        this.username = name;
        this.userpic = pic;
      }
    },
    searchBannerImg() {
      //查询广告图
      let me = this;
      getData("/recommend-lists?position=3&num=1")
        .then((res) => {
          if (res.code == 0) {
            me.banner = res.data[0].banner;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectKFImg() {
      //获取广告图片
      let me = this;
      getData("/recommend-lists?position=7")
        .then((res) => {
          if (res.code == 0) {
            var arr = [];
            arr = res.data.map((item) => {
              return item.banner.thumb_url;
            });
            me.images.push(...arr);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    me = this;
    this.getMyMessage();
    this.searchBannerImg();
    this.setMessage();
    this.getUserInfo();
    me.selectKFImg();
    me.getVipTimeOut();
    me.getUserStatus();
    me.checkUserIsVip();
    me.checkUserIsSVip();
    me.getRecommentList();
    me.getUseStatus();
    me.getIcpInfo();
  }
};
</script>

<style scoped>
.refresh {
  position: absolute;
  z-index: 99;
  right: -5px;
  width: 20px;
  bottom: -5px;
  height: 20px;
}
.listOne {
  display: flex;
}
.my-center {
  padding: 10px 5px 0;
  box-sizing: border-box;
  background: rgb(220, 220, 220);
  min-height: 100vh;
}
.company-mes {
  width: 100%;
  height: 84px;
  background: #fff;
}
.brage-icon {
	position: absolute;
	top: 10px;
	right: 10px;
	font-weight: bold;
	color: #882784;
	border: 1px solid #882784;
	line-height: 15px;
	font-size: 12px;
	height: 15px;
	padding: 1px 6px;
	border-radius: 9px;
}
.vip-dengji { margin: 0 !important;
  position: absolute;
  width: fit-content !important;
  right: 2px;
  bottom: 1px;
  font-size: 10px;
  color: #fff;
}
.brage-icon-active {
	position: absolute;
	top: 10px;
	right: 10px;
	background-color: #d43737;
	line-height: 15px;
	font-size: 12px;
	color: #fff;
	height: 15px;
	padding: 1px 6px;
	border-radius: 9px;
}
.head-img {
  width: 48px;
  height: 48px;
  margin-left: 24px;
  position: relative;
}
.copy-right {
	width: 100%;
	text-align: center;
	color: rgb(145, 145, 145);
	font-size: 12px;
}
.main-tag {
  margin-left: 10px;
}
.tag-small > div:nth-child(1) {
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.tag-small > div:nth-child(2) {
  font-size: 12px;
  background-color: #882784;
  color: #fff;
  padding: 2px 5px;
  border-radius: 10px;
  margin-left: 10px;
}
.tag-small > div:nth-child(3) {
  font-size: 12px;
  background-color: #882784;
  color: #fff;
  padding: 2px 5px;
  border-radius: 10px;
  margin-left: 10px;
}
.company-name {
  color: rgb(128, 128, 128);
  margin: 6px 0 0 0;
}
.service {
  /* width: 84px; */
  height: 50px;
  background: #fff;
  margin-right: 27px;
}
.service img {
  width: 100%;
  height: 100%;
}
.open {
  width: 29px !important;
  height: 14px !important;
  color: rgb(128, 128, 128);
  border-radius: 10px;
}
.service-pic {
  width: 17px;
  height: 19px;
}
.contact-service {
  margin-top: 5px;
}
.account {
  margin-top: 3px;
  width: 100%;
  height: 84px;
  background: #fff;
  padding: 20px 38px;
  box-sizing: border-box;
}
.wealthy-pic {
  width: 32px;
  height: 32px;
}
.rest-money {
  margin-left: 20px;
}
.history {
  padding: 10px 10px 5px;
  box-sizing: border-box;
  margin-bottom: 75px;
}
.payMoney {
  width: 100%;
}
.payMoney div {
  margin: 0px 5px;
  background-color: #d9cbd8;
  border-radius: 5px;
  height: 35px;
  font-size: 13px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 10px;
  color: #882784;
  margin-top: 10px;
  font-weight: bold;
}
</style>
